import styled, { css } from 'styled-components';
import { MenuItemOptionsType } from './Menu.component';

export const Menu = styled.div`
  position: relative;
`;

export const Button = styled.button`
  background-color: ${(props) => props.theme.colors['neutral-30']};
  width: 20px;
  height: 20px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: ${(props) => props.theme.colors['neutral-40']};
  }

  &:active {
    outline-color: ${({ theme }) => theme.colors['secondary-60']};
    outline-offset: 0px;
    outline-style: solid;
    outline-width: 3px;
  }
`;

export const MenuItems = styled.div`
  position: absolute;
  z-index: 1;
  border: 1px solid #ebebeb;
  right: 0;
  top: 25px;
  background: #fdfdfd;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.07);
  border-radius: 4px;
  min-width: 86px;
`;

const warningStyle = css`
  * {
    color: ${(props) => props.theme.colors['light-red']};
  }
`;

export const MenuItem = styled.button<MenuItemOptionsType>`
  background: transparent;
  border: none;
  display: inline-block;
  width: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 6px 12px;

  &:hover {
    background-color: ${({ theme }) => theme.colors['neutral-20']};
  }

  &:active {
    background-color: ${({ theme }) => theme.colors['neutral-30']};
  }

  svg {
    margin-right: 5px;
    width: 13px;
    height: 13px;
  }
  * {
    color: ${(props) => props.theme.colors['neutral-100']};
  }
  ${({ warning }) => warning && warningStyle};
`;

export const Label = styled.p`
  line-height: 15px;
  font-size: 14px;
  white-space: nowrap;
`;
